import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NavigationExtras} from "@angular/router";
import {NavController, PopoverController, ViewDidEnter} from "@ionic/angular";
import {ModelProvider} from "../../../../framework/providers/modelProvider/ModelProvider";
import {AdminService} from "../../../../core/services/AdminService";
import {BusinessService} from "../../../../core/services/BusinessService";
import {ModelToolsProvider} from "../../../../framework/providers/model-tools/model-tools";
import {SelectBarComponent} from "../select-bar/select-bar.component";
import {Events} from "../../../../framework/providers/events";
import {CalendarComponent} from "../calendar/calendar.component";
import {PickAddressComponent} from "../tools/pick-address/pick-address.component";
import {ViewChild, ViewContainerRef, ComponentFactoryResolver} from '@angular/core';
import {OrderService} from "../../../../core/services/OrderService";
import * as moment from "moment";
import {MainService} from "../../../../core/services/MainService";

declare var ICONS;

export interface ProcessComponent {
    data: any;
}

@Component({
    selector: 'app-view-field',
    templateUrl: './view-field.component.html',
    styleUrls: ['./view-field.component.scss'],
})
export class ViewFieldComponent implements OnInit, OnDestroy {

    // @ViewChild('processContainer', {read: ViewContainerRef}) container;

    filters = {'ordering': '-id', 'type': 'moving', 'name': 'taarif', 'modelOffset': 0, 'modelLimit': 20};

    @Input()
    topPrefix;
    @Input()
    prefix;
    @Input()
    filterMode = false;
    @Input()
    sectionName;
    @Input()
    tableInfoData;
    @Input()
    exTableData;

    @Input()
    showTitle = false;
    @Input()
    addMultiple = false;

    @Input()
    fieldType;
    @Input()
    fieldData;
    @Input()
    onTable = false;

    @Input()
    period;

    @Input()
    fieldKey;

    @Input()
    avoidSave;
    @Input()
    boxSmall;

    saveInterval;

    @Input()
    params = {'edit': false, 'fullView': true};
    deffaultFullView: boolean = false;

    icons = ICONS;
    searchIcon = '';
    extraClass = '';

    inError = false;

    //one filed supported to be tab fields.
    ready: boolean = false;
    currentTab = 0;

    // forceEdit = false;

    constructor(public events: Events, public modelProvider: ModelProvider,
                public adminService: AdminService,
                public popoverCtrl: PopoverController,
                public mainService: MainService,
                public orderService: OrderService,
                public businessService: BusinessService,
                public modelTools: ModelToolsProvider, public navCtrl: NavController) {
    }

    ngOnInit() {
        if (this.fieldKey) {
            this.fieldData = this.period[this.fieldKey];
            this.fieldType = this.adminService.getFieldsType(this.sectionName, this.exTableData)[this.fieldKey];
        }

        if (this.params['extraClass']) {
            this.extraClass = this.params['extraClass'];
        }

        if (this.params['editMode']) {
            this.fieldData['editMode'] = true;
        }

        if (this.addMultiple) {
            this.fieldType['multiple'] = true;
        }

        // let me = this;
        // if (me.fieldType) {
        //     me.forceEdit = ['filter', 'image', 'page', 'table', 'filterBuilder', 'htmlTemplate', 'equation', 'inventory']
        //         .indexOf(me.fieldType['type']) != -1;
        // }
        this.ready = true;

        //assume true
        if (this.params['fullView'] === null) {
            console.log('this.params[fullView] is null!!!')
            this.deffaultFullView = true;
        }

        if (this.fieldType['type'] == 'time') {
            if (this.fieldData['value'] == 'None') this.fieldData['value'] = "00:00:00";
            // this.fieldData['value'] = moment(this.fieldData['value']).format('HH:mm');
        }

        if (['number', 'float'].includes(this.fieldType['type'])) {
            if (this.fieldData['value'] == 0) this.fieldData['value'] = '';
        }

    }

    fieldEdit() {
        if (this.fieldType['readOnly']) {
            return;
        }

        //if field is table.
        if (this.fieldType['type'] == 'table') {
            return;
        }

        if (['number', 'float'].includes(this.fieldType['type'])) {
            let me = this;
            setTimeout(function () {
                me.fieldData['displayName'] = me.fieldData['value'];
                console.log(me.fieldData['displayName']);
            });
        }

        this.tableInfoData['updated'] = true;
        this.fieldData['edited'] = true;
        this.period['main']['updated'] = true;
        this.fieldData['editMode'] = true;
    }

    ngOnDestroy(): void {
        // this.fieldData['edited'] = false;
        // this.fieldData['editMode'] = false;
    }

    save() {
        if (this.avoidSave) return;
        clearTimeout(this.saveInterval);

        this.fieldData['fieldSaveWait'] = true;

        if (!this.validateField()) {
            this.fieldData['validate'] = false;
            return;
        }
        this.fieldData['validate'] = true;

        let me = this;
        this.saveInterval = setTimeout(function () {
            if (!me.validateField()) {
                me.fieldData['validate'] = false;
                return;
            }
            me.fieldData['validate'] = true;

            if (me.onTable) {
                let d = {'fieldData': me.fieldData, 'model': me.period, 'fieldType': me.fieldType};
                me.events.publish('save' + me.prefix, d);
            } else {
                me.saveField();
            }

            // me.fieldData['editMode'] = false;
        }, 2000);
    }

    validateField() {
        if (!this.fieldData['value']) return true;

        //check text length
        if (this.fieldType['type'] == 'text' || this.fieldType['type'] == 'textarea') {
            if (this.fieldData['value'].length >= this.fieldType['maxLength']) {
                this.inError = true;
                //console.log'text not valid');
                return false;
            }
        }

        //check is number
        if (this.fieldType['type'] == 'number' || this.fieldType['type'] == 'float') {
            if (!this.isNumeric(this.fieldData['value'])) {
                this.inError = true;
                //console.log'number not valid');
                return false;
            }
        }

        this.inError = false;

        return true;
    }

    openPage() {
        let me = this;
        let fieldData = this.fieldData;
        let fieldType = this.fieldType;
        //move to an other page
        //console.log"open page:");
        //console.logthis.fieldData);
        //console.logthis.fieldType);

        if (this.fieldType['type'] == 'map') {
            return;
        }
        if (fieldData['externalLink']) {
            if (fieldType['share']) {
                this.mainService.shareViewWhatsapp({'data': fieldData['externalLink']});
            } else {
                window.open(fieldData['externalLink']);
            }
            return;
        }

        if (this.fieldType['calendar']) {
            this.openCalendar(null, false, true, true);
        } else if (this.fieldType['areyousure']) {
            this.modelTools.yesOrNoAlert(function (data) {
                me.openPageAction();
            }, null, this.fieldType['areyousureText']);

        } else {
            this.openPageAction();
        }
    }

    // can try this if would find a bug here:
    // let filters = {};
    // filters['sectionName'] = this.sectionName;
    // filters['search_in_field'] = true;
    // filters['searchField'] = modeldata['filterkey'];
    // filters['searchFieldValue'] = modeldata['value'];
    //
    // this.events.publish('table_refresh_request_' + this.prefix, filters);
    openPageAction() {
        let me = this;
        let fieldData = this.fieldData;
        let fieldType = this.fieldType;

        if (this.fieldType['type'] == 'filter') {
            let filter = {};
            filter['baseFilter'] = JSON.stringify({
                'searchField': this.fieldType['filterkey'],
                'searchFieldValue': this.fieldData['value']
            });
            filter['extradata'] = this.fieldType['extradata'];
            this.events.publish('refresh_request_' + this.prefix, filter);
            return;
        }

        //click buttons and so

        if (this.fieldType['serverCall']) {
            let filters = {
                'page': fieldData['pagePrefix'],
                'id': fieldData['value'],
                'saveAndGetIdPrefix': fieldData['saveAndGetIdPrefix'],
                'manager': 1
            };
            for (let key in this.fieldData['extraFilters']) {
                filters[key] = this.fieldData['extraFilters'][key];
            }

            this.modelProvider.custom(this.fieldData['serverCall'], filters, this.fieldData['domain'])
                .then(function (data) {
                    //console.log'results:');
                    //console.logdata);

                    me.modelTools.presentToast('DONE!');
                    me.period[0]['updated'] = true;
                    me.fieldData['updated'] = true;
                    me.fieldData['serverCallGo'] = true;
                    me.events.publish('saveAndOpenPage' + me.prefix, {});
                });

            return;
        } else if (this.fieldType['quickOpen']) {
            //console.log'quickOpen!!!!');

            let data = {
                'page': this.fieldType['pagePrefix'],
                'id': this.fieldData['value'],
                'saveAndGetIdPrefix': this.fieldData['saveAndGetIdPrefix'],
                'manager': 1
            };

            let page = data['page'];
            if (this.fieldType['pageModelId']) {
                page += "/" + this.fieldData['value'];
            }

            let navigationExtras: NavigationExtras = {
                queryParams: data
            };
            this.navCtrl.navigateForward(page, navigationExtras);

            return;
        } else if (this.fieldType['saveAndGetId']) {

            if (!this.fieldType['unlimitedClick'] && this.fieldData['pageClickedAlready']) {
                me.modelTools.presentToast('Already done.');
                return;
            }
            this.fieldData['pageClickedAlready'] = true;

            // fieldData['createEstimate'] = true;
            Object.assign(this.filters, {
                'page': fieldType['pagePrefix'],
                'id': fieldData['value'],
                'saveAndGetIdPrefix': fieldType['saveAndGetIdPrefix'],
                'manager': 1
            });
            let tableData = {};
            this.period['main']['updated'] = true;
            tableData[this.sectionName] = [this.period];

            this.filters['editedSections'] = [this.sectionName];
            this.filters['sectionName'] = this.sectionName;

            this.modelProvider.customPost('saveDataReport', [tableData], this.filters, true).then((data: any) => {
                if (me.fieldType['afterSaveMsg']) {
                    me.modelTools.presentToast(me.fieldType['afterSaveMsg']);
                }

                for (let key in data['data']['models'][0]) {
                    // if (key == 'id' || key == 'main') continue;
                    this.period[key] = data['data']['models'][0][key];
                }

                //    open result model?

            });

        }
    }

    openTableModelOptions() {
        this.events.publish('openTableModelOptions' + this.prefix, {'model': this.period, 'fieldData': this.fieldData});
    }

    //open specific model page
    openAdminModel(sectionName, id = '') {
        //console.logsectionName, id);

        let params;
        params = {
            'sectionName': sectionName,
            'baseFilter': {
                'searchFieldValue': id,
                'searchField': 'id',
                'search_in_field': true
            },
            'rowIndex': 1 //skip first row -1
        };

        let navigationExtras: NavigationExtras = {
            queryParams: params
        };
        this.navCtrl.navigateForward('admin-model/' + sectionName + id, navigationExtras);
    }

    callFieldEvent(model, fieldData) {
        //console.logfieldData['event']);
        this.events.publish(fieldData['event'], {'model': model});
    }

    selectFieldPopup(event) {
        this.period[0]['updated'] = true;
        this.fieldData['edited'] = true;
        return
        this.events.publish('selectFieldPopup' + (this.topPrefix ? this.topPrefix : this.prefix), {
            'fieldData': this.fieldData,
            'tableData': this.tableInfoData
        });
    }

    async openCalendar(myEvent, mini = true, modeleventsType = false, force = false) {
        if (this.fieldType['readOnly'] && !force) return;

        this.adminService.popupEditBoxByData(null, {
            'miniCalendar': mini,
            'avoidSave': this.avoidSave,
            'modeleventsType': modeleventsType,
            'dateModel': this.period,
            'dateModelSectionName': this.sectionName,
            'dateFieldData': this.fieldData,
            'dateFieldType': this.fieldType,
            'tableData': this.exTableData,
            'prefix': this.prefix,

            'exTableData': this.exTableData
        }, true, CalendarComponent);
    }

    //from eye of select table
    async presentSelectBar(myEvent, type, getId = null, sectionName = null, model = null, popoverSize = null) {
        this.fieldData['modelId'] = this.period['id']['value'];
        this.fieldData['mainDisplayName'] = this.period['main']['displayName'];

        let bigPopup;
        if (popoverSize)
            bigPopup = true;//popoverSize;
        else if (this.fieldType['popoverSize'])
            bigPopup = true;// = this.fieldType['popoverSize'];
        else if (this.fieldType['type'] == 'table')
            bigPopup = true;// = 'bigger-popover';
        else bigPopup = false;// = 'smaller-popover';
        // console.log('open popup - ', size)

        this.adminService.popupEditBoxByData(myEvent, {
            'model': model ? model : getId ? null : this.period, // if search by id so dont send model - it will query it from server
            'getModelById': getId,
            'avoidSave': this.avoidSave,
            'prefix': this.prefix,
            'tableInfoData': this.exTableData[(sectionName ? sectionName : this.sectionName) + 'Data'],
            'fieldData': this.fieldData,
            'fieldType': this.fieldType,
            'exTableData': this.exTableData,
            'sectionName': sectionName ? sectionName : this.sectionName,//if select options and not select table.
            'type': type,
            'onTable': this.onTable
        }, bigPopup);

        // 'tableInfoData': this.tableInfoData,
        // const popover = await this.popoverCtrl.create({
        //     component: SelectBarComponent,
        //     componentProps: {
        //         'model': model ? model : getId ? null : this.period, // if search by id so dont send model - it will query it from server
        //         'getModelById': getId,
        //         'avoidSave': this.avoidSave,
        //         'prefix': this.prefix,
        //         'tableInfoData': this.exTableData[(sectionName ? sectionName : this.sectionName) + 'Data'],
        //         'fieldData': this.fieldData,
        //         'fieldType': this.fieldType,
        //         'exTableData': this.exTableData,
        //         'sectionName': sectionName ? sectionName : this.sectionName,//if select options and not select table.
        //         'type': type,
        //         'onTable': this.onTable
        //     },
        //     event: this.fieldType['type'] != 'table' && myEvent ? myEvent : null,
        //     animated: true,
        //     showBackdrop: true,
        //     cssClass: 'note-popover icenter-popover ' + size
        // });
        //right-popup
        // return await popover.present();
    }

    saveField() {
        let fieldType = this.fieldType;
        let fieldData = this.fieldData;
        let me = this;

        let newModel = {
            'main': {'value': this.period['id']['value'], 'updated': true, 'name': '', 'type': 'none'},
            'id': this.period['id']
        };

        newModel[fieldType['name']] = {
            'value': fieldData['value'],
            'value2': fieldData['value2'],
            'name': fieldType['name'],
            'edited': true,
            'type': fieldType['type'],
            'typeData': fieldType
        };

        let tableData = {};
        tableData[this.sectionName] = [newModel];

        this.filters['editedSections'] = [this.sectionName];
        this.filters['sectionName'] = this.sectionName;

        this.modelProvider.customPost('saveDataReport', [tableData], this.filters, true).then((data: any) => {
            me.exTableData[me.sectionName + 'Data']['edited'] = false;
            me.period['main']['updated'] = false;
            me.fieldData['edited'] = false;
            me.fieldData['displayName'] = data['data']['models'][0]['displayName'];
            me.fieldData['fieldSaveWait'] = false;

            //update calendar
            if (['date', 'datetime'].includes(me.fieldType['type'])) {
                me.events.publish('calendarRefresh', {'fieldData': me.fieldData});
            }
        });
    }

    chooseColor(color) {
        //console.log'choose color:', color);
        this.fieldData['value'] = color;
        this.fieldData['color'] = color;
        this.period['main']['color'] = color;
        this.save();
        this.fieldData['editMode'] = false;
    }

    isNumeric(str: any) {
        // if (typeof str != "string") return false; // we only process strings!
        //
        return (!isNaN(str) && !isNaN(parseFloat(str))) // ...and ensure strings of whitespace fail
        // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    }

    async mapSelect(myEvent) {
        const popover = await this.popoverCtrl.create({
            component: PickAddressComponent,
            componentProps: {},
            event: myEvent,
            animated: true,
            showBackdrop: true,
            cssClass: 'note-popover icenter-popover bigger-popover'
        });
        return await popover.present();
    }

    openExternalLink() {
        window.open(this.fieldData['value'], '_blank');
    }

    // equations tags
    addTagToField(tag, fieldData) {
        if (!fieldData['value']) fieldData['value'] = '';

        fieldData['value'] += "[" + tag + "]";
    }

    booleanClick() {
        this.fieldData['value'] = !this.fieldData['value'];
        this.fieldData['icon'] = this.fieldData['value'] ? 'checkmark' : 'square';
        this.fieldData['color'] = this.fieldData['value'] ? 'success' : 'danger';
    }


    //change company
    //set cart info on cart service
    startInventory() {
        this.orderService.changeAgentCompany(null, this.period['company']['value']);
        this.events.subscribe('agentCompanyChanged', () => {
            // this.events.unsubscribe('agentCompanyChanged');
            //to orderService - will show on profile page the open carts.
            // this.orderService.savedCartList = this.fieldData['cartData'];

            this.orderService.initCart();
            this.orderService.loadCartFromData({
                'cartId': this.fieldData['cartId'],
                'cart': this.fieldData['cartData'],
                'cartData': this.orderService.cartData
            }, false);
            // this.orderService.doCartCalc();

            this.navCtrl.navigateForward('cart');
        });
    }

    nextPage(e) {
        console.log('next page!!!');
        this.events.publish('nextPage' + this.prefix + 'SubTable');
        // this.events.subscribe()
        setTimeout(function () {
            e.target.complete();
        }, 2000);
    }

    // public getComponent(comName) {
    //     const factory = this.resolver.resolveComponentFactory(comName);
    //     let componentRef = this.container.createComponent(factory);
    //     // (<ProcessComponent>componentRef.instance);
    // }
    //
    // private resolveComponentsName(step) {
    //     if (step === 1) {
    //         return AppImgComponent;
    //     } else if (step === 2) {
    //         return AppImgComponent;
    //     } else if (step === 3) {
    //         return AppImgComponent;
    //     }
    // }

}
